<template>
  <v-card-text>
    <v-card v-if="paymentMethod" elevation="0" class="payment-method">
      <span>
        <v-row>
          <v-col class="header-text" :cols="6">Current Credit Card</v-col>
          <v-col class="header-text header-right" :cols="6">Exp</v-col>
        </v-row>
      </span>
      <span>
        <v-row>
          <v-col class="line-text" :cols="6"
            >XXXX XXXX XXXX {{ paymentMethod.card.last4 }}</v-col
          >
          <v-col class="line-text header-right" :cols="6"
            >{{ getMonth(paymentMethod.card.expMonth) }}
            {{ paymentMethod.card.expYear }}</v-col
          >
        </v-row>
      </span>
    </v-card>

    <span style="">
      <hr class="header-line" />

      <form class="mt-4" id="payment-form">
        <div id="card-element"></div>
        <div style="color: red" id="card-element-errors"></div>
        <v-btn color="info" class="submit-button mt-6" small type="submit"
          >{{ paymentMethod ? "Change" : "Add" }} Payment Method</v-btn
        >
      </form>
    </span>
    <hr class="header-line" />
  </v-card-text>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js/pure";
import axios from "axios";
import { bus } from "@/main";
import Vue from "vue";
import { getStripePKey } from "@/helpers/api";

export default Vue.extend({
  name: "EditPaymentMethodModal",
  props: ["paymentMethod", "customer", "failedInvoices"],
  data() {
    return {
      dialog: false,
      stripe: null,
      elements: null,
      card: null,
      loading: false
    };
  },
  async mounted() {
    const spk = await getStripePKey();
    this.stripe = await loadStripe(spk);
    this.elements = await this.stripe.elements();
    setTimeout(() => {
      this.createCard();
      const signupForm = document.getElementById("payment-form");
      signupForm.addEventListener("submit", evt => {
        evt.preventDefault();
        this.createPaymentMethod();
      });
    }, 100);
  },
  methods: {
    getMonth(month) {
      const months = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      return months[month].substring(0, 3);
    },
    createPaymentMethod() {
      this.stripe
        .createPaymentMethod({
          type: "card",
          card: this.card,
          billing_details: {
            name: this.customer.name
          }
        })
        .then(result => {
          if (result.error) {
            this.error = result.error;
            bus.$emit("loadingOff");
            bus.$emit("errorSnack", result.error);
          } else {
            this.changePaymentMethod(
              result.paymentMethod.id,
              this.failedInvoices
            )
              .then(() => {
                bus.$emit("successSnack", "Payment method updated!");
              })
              .catch(() => {
                bus.$emit("loadingOff");
                bus.$emit(
                  "errorSnack",
                  "Payment method could not be be processed. Please verify your card info."
                );
              });
          }
        });
    },
    displayError(event) {
      // changeLoadingStatePrices(false);
      const displayError = document.getElementById("card-element-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    },
    async changePaymentMethod(paymentMethodId, failedInvoices) {
      bus.$emit("loadingOn", "Loading...");

      const invoicesArray = failedInvoices
        ? failedInvoices.map(invoice => invoice.id)
        : [];

      if (this.paymentMethod) {
        await axios.get(
          `/rest-api/payments/detach/payment/method/${this.paymentMethod.id}`
        );
        await this.addCard(paymentMethodId, invoicesArray);
      } else {
        await this.addCard(paymentMethodId, invoicesArray);
      }
      this.$emit("close-dialog");
      this.$emit("update-payment");
      bus.$emit("loadingOff", "Loading...");
    },
    async addCard(paymentMethodId, invoices) {
      return await axios.post(
        `/rest-api/payments/add/customer/card/${this.customer.id}/${paymentMethodId}`,
        invoices
      );
    },
    createCard() {
      const style = {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };

      // Create an instance of the card Element.
      this.card = this.elements.create("card", { style: style });
      this.card.mount("#card-element");
      this.card.on("change", event => {
        this.displayError(event);
      });
    }
  },
  watch: {
    dialog: function() {
      setTimeout(() => {
        this.createCard();
        const signupForm = document.getElementById("payment-form");
        signupForm.addEventListener("submit", evt => {
          evt.preventDefault();
          this.createPaymentMethod();
        });
      }, 100);
    }
  }
});
</script>

<style scoped>
.payment-method {
  border-radius: 7px;
  padding-bottom: 10px;
}
.header-text {
  padding-bottom: 0px;

  opacity: 0.6;
  color: #1e2433;
  font-size: 12px;
}
.header-right {
  display: flex;
  justify-content: flex-end;
}
.line-text {
  font-size: 14px;
  font-weight: 500;
  padding-top: 5px;
  padding-bottom: 20px;
}
.submit-button {
  display: flex;
  margin-left: auto;
  margin-bottom: 20px;
}
.header-line {
  opacity: 0.15;
  margin-top: -5px;
}
</style>
